import { createContext, useContext } from 'react';

import { Lesson } from '~/models/Lesson';

const LessonContext = createContext<Lesson>(new Lesson());

export const useLessonContext = () => useContext(LessonContext);

export default LessonContext;
